import { LocalStorageService } from './../../../core/services/local-storage.service';
import { environment } from './../../../../environment/environment';
import { SalarieService } from './../../../core/services/salarie-service/salarie.service';
import { Component, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  ICandidat,
  headerColumns2,
  listContracts,
  statusCandidate,
} from './../../../core/models/candidat';
import {
  EmptyCV,
  emptyFileTest,
  noCvSelected,
  noTestFileSelected,
  obligationSelect,
  serverError,
} from './../../../core/models/messages';
import { EsnCandidatService } from './../../../core/services/esn-candidat/esn-candidat.service';
import { SortDataService } from './../../../core/services/sortdata';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Country, State } from 'country-state-city';
import * as saveAs from 'file-saver';
import * as JSZip from 'jszip';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { translations } from '../../../core/models/call-offer';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-candidatclientfinal',
  templateUrl: './candidatclientfinal.component.html',
  styleUrls: ['./candidatclientfinal.component.css'],
})
export class CandidatclientfinalComponent {
  compt = [
    { id: 1, name: 'Immédiate' },
    { id: 2, name: '2 mois' },
    { id: 3, name: '3 mois' },
    { id: 4, name: '4 mois' },
    { id: 5, name: '5 mois' },
  ];

  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
    
  ];

  contratRequest = listContracts;
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },

  ];
 disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  isCollapsed = true;
  ischecked = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  stateList: any = [];
  seeMore: boolean = false;
  loadSpinnerTable: boolean = false;
  loadSpinner: boolean = false;
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  dataHeader: any = [];
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  currentSortDirection: number = 2;
  listcandidats: any;
  listNames: string[] = [];
  pagination : boolean =false;
  isLoadSpinner: boolean = true;

  sortAttr = '';
  statut = statusCandidate;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  headerChecked: boolean = false;
  selectedCandidats: any = [];
  searchForm: FormGroup = this.createSearchForm();
  skillsList: { name_FR: string }[] = [];
  mobilities: any[] = [];
  countries: any[] = [];
  selectedCandidates: any = [];
  idsUsers: any[] = [];
  currentSortColumn: string = 'name'; // Initial column to sort by
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns2;
  // Ajouter cette variable dans votre composant
  downloadCounter: number = 0;
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private candidatservice: EsnCandidatService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private salarieservice: SalarieService,
    private sortDataService: SortDataService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig,
    private elRef: ElementRef,
  ) {}
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.getListcandidat();
    this.getListSkills();
    this.getListElementHeader();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
      console.log('HEYYYYYYYYYYYY');
    }
  }
  sortData(item: string) {
    for (const iterator of headerColumns2) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;
    if (this.searchForm.dirty)
      this.listcandidats = this.sortDataService.sortArray(
        this.listcandidats,
        item,
        this.currentSortDirection
      );
    else this.getListcandidat();
  }
  translateCountryName(name: string): string {
    
    return translations[name] || name;
  }

  /* get indexes for pagination */
  getItems(event?: any) {
    console.log('evnet', event);

    if (
      (event && event.startIndex != this.startIndex) ||
      this.endIndex != event.endIndex ||
      this.itemsPerPage != event.itemsPerPage ||
      this.currentPage != event.currentPage
    ) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchCandidat();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListcandidat();
      }
    }
  }
  
  getListElementHeader() {
    // if(!this.typeintervenant){
    this.candidatservice
      .getHeaderElementscandidatcf(18)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.isLoadSpinner = false;
          this.dataHeader = res.data;
          for (const iterator of this.dataHeader) {
            if (
              (iterator.checked == 'oui' && !iterator.checked_user) ||
              (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
              (iterator.checked == 'oui' && iterator.checked_user == 'oui')
            )
              this.listNames.push(iterator.name);
          }
          this.dataHeader.map((el: any) => {
            if (
              (el.checked == 'oui' && !el.checked_user) ||
              (el.checked_user == 'oui' &&
                (el.checked == 'non' || el.checked == 'oui'))
            ) {
              return (el.checkAdmin = true);
            } else {
              return (el.checkAdmin = false);
            }
          });
        },
        error: () => {},
      });
    // }
    // else
    // {
    //   this.candidatservice
    //   .listPageActorIntervenant()
    //   .pipe(takeUntil(this.unsubscribeAll))
    //   .subscribe({
    //     next: (res) => {
    //       this.dataHeader = res.data;
    //       for (const iterator of this.dataHeader) {
    //         if (
    //           (iterator.checked == 'oui' && !iterator.checked_user) ||
    //           (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
    //           (iterator.checked == 'oui' && iterator.checked_user == 'oui')
    //         )
    //           this.listNames.push(iterator.name);
    //       }
    //       this.dataHeader.map((el: any) => {
    //         if (
    //           (el.checked == 'oui' && !el.checked_user) ||
    //           (el.checked_user == 'oui' &&
    //             (el.checked == 'non' || el.checked == 'oui'))
    //         ) {
    //           return (el.checkAdmin = true);
    //         } else {
    //           return (el.checkAdmin = false);
    //         }
    //       });
    //     },
    //     error: () => { },
    //   });
    // }
  }

  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    // if(!this.typeintervenant)
    //   {
    let payload = {
      sub_page_id: data?.id,
    };
    this.candidatservice
      .changeDelectedElementHeadercandidatcf(payload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {},
        error: () => {},
      });
    // }
    // else{
    //   let payload = {
    //     sub_page_id: data?.id
    //   }
    //   this.candidatservice.changeSubPageStateIntervenant(payload).pipe(takeUntil(this.unsubscribeAll)).subscribe({
    //     next: (res) => {

    //     },
    //     error: () => {

    //     }
    //   })
    // }
  }

  navigateToCompareCandidats() {
    const nombreCoches = this.selectedCandidats.filter(
      (el: ICandidat) => el.checked
    ).length;
    if (nombreCoches > 3) {
      this.ischecked = false;
      this.toastrService.error(
        'Impossible de sélectionner plus de 3 candidats'
      );
    } else {
      const selectedIds = this.selectedCandidats.map(
        (candidat: any) => candidat.id
      );
      const queryParams = { candidatsIds: selectedIds };
      const url = [
        '/candidats/compare-candidats',
        { candidatsIds: selectedIds },
      ];
      // Opening link in a new tab
      window.open(this.router.createUrlTree(url).toString(), '_self');
      this.selectedCandidats = [];
      this.ischecked = true;
    }
  }

  rowClick(candidat: ICandidat, index: number) {
    this.listcandidats[index].checked = !this.listcandidats[index].checked;
    if (this.listcandidats[index].checked) {
      this.selectedCandidats.push(candidat);
    } else {
      const selectedIndex = this.selectedCandidats.findIndex(
        (item: any) => item === this.listcandidats[index]
      );
      if (selectedIndex !== -1) {
        this.selectedCandidats.splice(selectedIndex, 1);
      }
    }
  }

  getListcandidat() {
    console.log('bb');
    this.spinner.show();
    this.loadSpinnerTable = true;
    let dataPyload =
      this.sortAttr == ''
        ? { per_page: this.itemsPerPage, page: this.currentPage }
        : {
            ...{ per_page: this.itemsPerPage, page: this.currentPage },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.candidatservice.getListcandidat(dataPyload).subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.data.users.data.length) {
          this.listcandidats = response.data.users.data
          // .slice(0, this.endIndex);
          this.totalItems = response.data.users.total;
          this.spinner.hide();
          this.updateCandidats()

          console.log('list candidats', this.listcandidats);
        }
      },
      error: (error) => {
        this.spinner.hide();
        console.error('Error fetching salaries: ', error);
      },
    });
  }
  updateCandidats() {
    let count = 0;
    this.headerChecked = false;
    this.listcandidats.forEach((candidate :any) => {
      // Check if the candidate's ID exists in selectedCandidats
      const isSelected = this.selectedCandidats.some((selected :any) => selected.id === candidate.id);
      // Update the `checked` property based on the existence in selectedCandidats
      if (isSelected) {
        candidate.checked = true;
        candidate.headerChecked =true;
        count++;

      }
      if (this.selectedCandidats.length === this.itemsPerPage && count == 5 ) {
        this.headerChecked = true;
      }
    });
   

  }

  downloadFiles(type: string, fileName?: any, typeFile?: string) {
    console.log('type', type);
    if (type == 'single' && fileName) {
      if (fileName.cv || fileName.file_test_anonymous) {
        const fileUrl = !typeFile
          ? `${this.url}/User/file/gallery_cvs/${fileName.cv}`
          : `${this.url}/ResponseCandidate/GetFileAnonymize/${fileName?.file_test_anonymous}`;
        this.showGlobalSpinner();
        this.candidatservice.downloadFile(fileUrl).subscribe(
          (data) => {
            const blob = new Blob([data], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = !typeFile
              ? `${fileName.ID_user}_${fileName.first_name}_${fileName.last_name
              }_CV.${fileName!.cv.split('.').pop()}`
              : `${fileName.ID_user}_${fileName.first_name}_QCM.${fileName!.file_test_anonymous}`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);

            this.hideGlobalSpinner();
          },
          () => {
            this.hideGlobalSpinner();
          }
        );
      } else {
        this.toastrService.info(EmptyCV);
      }
    } else if (this.selectedCandidats.length) {
      console.log('selectedcandidat', this.selectedCandidats);
      console.log('typefile', typeFile);

      if (!typeFile) {
        let allCvNull = true;

        // Vérifie chaque candidat pour voir s'il a un CV valide
        for (let i = 0; i < this.selectedCandidats.length; i++) {
          const candidat = this.selectedCandidats[i];
          console.log('candidat', candidat);
          if (candidat.cv && candidat.cv !== 'null') {
            allCvNull = false; // S'il y a un CV valide, marquez allCvNull comme false et sortez de la boucle
            break;
          }
        }
        console.log('allCvNull', allCvNull);
        if (allCvNull) {
          this.toastrService.info(noCvSelected);
        } else {
          this.downloadPdfFiles(typeFile);
        }
      } else {
        let datafileTest = this.selectedCandidats.map((el: any) => {
          return !el.file_test;
        });
        if (!datafileTest.includes(false)) this.toastrService.info(noTestFileSelected);
        else if (
          this.selectedCandidats.length == 1 &&
          !this.selectedCandidats[0].file_test_anonymous
        )
          this.toastrService.info(emptyFileTest);
        else this.downloadPdfFiles(typeFile);
      }
    } else {
      this.toastrService.info(obligationSelect);
    }
  }
  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test_anonymous: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {

          return {
            url: `${this.url}/ResponseCandidate/GetFileAnonymize/${el?.file_test_anonymous}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test_anonymous
          };
        }
      }
    );
    // this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          () => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip');
          this.selectedCandidats = [];
          this.headerChecked = false;
          this.searchCandidat();
        } else {
          saveAs(content, 'Réponse_qcm.zip');
          this.selectedCandidats = [];
          this.headerChecked = false;
          this.searchCandidat();
        }
      });
    });
    this.selectedCandidats.map((el: ICandidat) => {
      el.checked = false;
    });
    this.headerChecked = false;
    this.selectedCandidats = [];
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }

  exportCandidats(file?: File) {
    if (this.selectedCandidats.length > 0) {
      if (this.selectedCandidats.length <= 3) {
        for (const iterator of this.selectedCandidats) {
          this.idsUsers.push(iterator.id);
        }
        let exportSuccess = false;
        let data = this.idsUsers;
        console.log(this.idsUsers);
        this.candidatservice.exportCandidatanonyme(file, data).subscribe({
          next: (res: any) => {
            this.spinner.hide();
            const blob = new Blob([res], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            saveAs(blob, 'RH_Profils.xlsx');
            exportSuccess = true;
            if (exportSuccess) {
              this.toastrService.success('Fichier exporté avec succès');
            }
            ;
            this.selectedCandidats.map((el: ICandidat) => {
              el.checked = false;
            });
            this.headerChecked = false;
            this.selectedCandidats = [];
            this.searchCandidat()
          },
          error: () => {
            this.spinner.hide();
            this.toastrService.error(serverError);
          },
        });
      } else {
        this.spinner.hide();
        this.toastrService.info('Veuillez sélectionner  max trois candidats.');
      }
    } else {
      this.spinner.hide();
      this.toastrService.info('Veuillez sélectionner au moins un candidat.');
    }
  }

  downloadreponse(candidat: any) {
    this.spinner.show();
    const fileUrl = `${this.url}/User/file/gallery_cvs/${candidat.file_test}`;
    this.candidatservice.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = `${candidat.ID_user}_${candidat.first_name}_${
        candidat.last_name
      }_CV.${candidat.cv.split('.').pop()}`;
      document.body.appendChild(a);
      a.click();
      this.spinner.hide();
    });
    // }
  }

  /* get candidats selected */
  fromSelection: boolean = false;
  
  changeSelectCandidats(event: any, type: string, candidat?: ICandidat) {
    if (type === 'allCandidats') {
      this.fromSelection = event.target.checked ? true : false;
      this.headerChecked = event.target.checked;
      this.selectedCandidats = event.target.checked
        ? [...this.listcandidats]
        : [];
  
        console.log("event.target.checked is ",event.target.checked)
      // Mettez à jour la propriété checked pour chaque candidat dans selectedCandidats
      this.selectedCandidats = this.selectedCandidats.map((el: ICandidat) => {
        el.checked = event.target.checked;
         return el
      });
      console.log(" is ",this.selectedCandidats)
      if (this.headerChecked === false) {
        this.listcandidats.forEach((candidate: any) => {

          candidate.checked = false;

        });
      }
  
      // Obtenez le nombre de cases à cocher sélectionnées
      const nombreCoches = this.selectedCandidats.filter(
        (el: ICandidat) => el.checked
      ).length;
  
      console.log(`all Nombre de cases à cocher sélectionnées : ${nombreCoches}`);
  
      if (nombreCoches > 3) {
        this.ischecked = false;
      } else {
        this.ischecked = true;
      }
      console.log('ischecked', this.ischecked);
    } else {
      if (candidat) {
        const isAlreadySelected = this.selectedCandidats.some(
          (el: ICandidat) => el.id === candidat.id
        );
  
        if (event.target.checked) {
          if (!isAlreadySelected) {
            this.selectedCandidats.push(candidat);
            candidat.checked = true; // Mettez à jour la propriété checked pour le candidat spécifique
          }
        } else {
          let indexId = this.selectedCandidats.findIndex(
            (el: { id: number }) => el.id === candidat.id
          );
          if (indexId !== -1) {
            this.selectedCandidats.splice(indexId, 1);
            candidat.checked = false; // Mettez à jour la propriété checked pour le candidat spécifique
          }
        }
  
        // Obtenez le nombre de cases à cocher sélectionnées
        const nombreCoches = this.selectedCandidats.filter(
          (el: ICandidat) => el.checked
        ).length;
  
        console.log(`Nombre de cases à cocher sélectionnées : ${nombreCoches}`);
  
        if (nombreCoches > 3) {
          this.ischecked = false;
        } else {
          this.ischecked = true;
        }
        console.log('ischecked', this.ischecked);
      }
      this.updateCandidats()

    }
  }
  
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
        console.log('list skills', this.skillsList);
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_user: ['', data?.ID_user],
      name: ['', data?.name],
      email: ['', data?.email],
      score: ['', data?.score],
      current_country: [null, data?.current_country],
      status: [null, data?.status],
      date_last_update: ['', data?.date_last_update],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      mobility: [[], data?.mobility],
      destination_country: [[], data?.destination_country],
      desired_workstation: ['', data?.desired_workstation],
      desired_contract: [[], data?.desired_contract],
      min_experience_years: ['', data?.min_experience_years],
      max_experience_years: ['', data?.max_experience_years],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }
 
 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}
  /* search */
  searchCandidat() {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range.toString()
    );
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');
    let data = {
      name: valueForm.name,
      score: valueForm.score,
      status: valueForm.status,
      ID_user: valueForm.ID_user,
      date_last_update: valueForm.date_last_update
        ? moment(valueForm.date_last_update).format('YYYY-MM-DD')
        : null,
      skillsOr: valueForm.skillsOr,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      skillsAnd: valueForm.skillsAnd,
      availability: valueForm.availability,
      desired_workstation: valueForm.desired_workstation,
      mobility: valueForm.mobility,
      desired_contract: valueForm.desired_contract,
      min_experience_years: valueForm.min_experience_years,
      max_experience_years: valueForm.max_experience_years,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      desired_salary: valueForm.desired_salary,
      desired_salary_range: valueForm.desired_salary_range,
      current_country: valueForm.current_country
        ? valueForm.current_country
        : '',
      destination_country: valueForm.destination_country
        ? valueForm.destination_country
        : '',
      page: this.currentPage,
      per_page: this.itemsPerPage,
      search: this.transformSearch(valueForm?.search),
    };
    console.log('data', data);
    this.spinner.show();
    this.candidatservice.searchcandidat(data).subscribe({
      next: (resSearch) => {
        if (this.currentPage > 1) {
          this.currentPage = 1;
          this.searchCandidat();
          this.spinner.hide();
          console.log('response search', resSearch);
        } else {
          this.listcandidats = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
        }
        this.updateCandidats()
      },
      error: (error) => {
        console.log(error);
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  transformSearch(search: string): string {
    console.log('alll',search)

    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');
    console.log('alll',search.trim())

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  /* key inter number */
  keyPress(event: any) {
    let pattern = /^[\d]$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && pattern && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    return pattern;
  }

  /* change country select and delete the string Governorate from state name*/
  onCountryChange(mode: string): void {
    this.searchForm.get('mobility')?.enable();
    this.countries = this.searchForm.get('destination_country')?.value;
    this.countries = this.countries.map(
      (item) => this.paysList.filter((it) => it.name === item)[0]
    );

    console.log('item of countries ', this.countries);
    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    console.log('stateList ', this.stateList);
    this.mobilities = this.searchForm.get('mobility')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      console.log('size of mobilities ', this.mobilities.length);
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('mobility')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('mobility')?.setValue(null);
    }
  }

  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('mobility')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('destination_country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        console.log('difference1 : ', difference1.length);
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            console.log('new_array is ', item.name);
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('destination_country')?.setValue(new_array);
          } else {
            console.log('String not found in array.', item.name);
          }
        }
      }
    });

    console.log('stateListAfter1 ', stateListAfter1);

    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('mobility')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('mobility')?.disable();
      mode == 'add';
      this.searchForm.get('destination_country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('mobility')?.setValue(null);
      this.searchForm.get('destination_country')!.updateValueAndValidity();
      this.searchForm.get('mobility')!.updateValueAndValidity();
      this.stateList.length = 0;
    } else {
      /*  if(this.countries) {
        this.countries.forEach((item) => {
          console.log('item of countries ', item);
  
        });
      }*/
    }
  }

  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  getFormattedDate(): string {
    const dateValue = this.searchForm.get('date_last_update')!.value;

    return moment(dateValue).format('DD/MM/YYYY');
  }
  reset() {
    this.stateList=[];
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchCandidat();
  }

  toggleCandidateSelection(candidateID: string): void {
    const index = this.selectedCandidates.indexOf(candidateID);
    if (index === -1) {
      this.selectedCandidates.push(candidateID);
    } else {
      this.selectedCandidates.splice(index, 1);
    }
  }
  redirectToLinkedIn(linkedinLink: string): void {
    window.open(linkedinLink, '_blank');
  }

  toggleRowSelection(candidat: ICandidat): void {
    candidat.checked = !candidat.checked;

    // Mettre à jour la sélection globale en fonction des cases individuelles
    this.headerChecked = this.listcandidats.every((c:any) => c.checked);

    // Mettre à jour la liste des candidats sélectionnés
    if (candidat.checked) {
      if (
        !this.selectedCandidats.some((el: ICandidat) => el.id === candidat.id)
      ) {
        this.selectedCandidats.push({ ...candidat, checked: true });
      }
    } else {
      this.selectedCandidats = this.selectedCandidats.filter(
        (el: ICandidat) => el.id !== candidat.id
      );
    }
  }
}
